"use client";

import * as React from "react";
import {
  Text,
  SectionCard,
  CardTitle,
  CardDescription,
  Section,
  EmptyState,
  Button,
} from "@/src/components";
import { Inbox, Search, FileX } from "lucide-react";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsEmptyState() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Empty State
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Displayed when there's no data to show, with optional icon, title, description, and actions.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/empty-state" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Empty states for different scenarios</CardDescription>
            </>
          }
          contentClassName="p-6 space-y-8"
        >
          <EmptyState
            icon={<Inbox className="h-12 w-12" />}
            heading="No messages"
            description="You don't have any messages yet. Start a conversation!"
            actions={<Button>Send a message</Button>}
          />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">icon</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Icon to display</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">heading</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Heading text</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">description</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Description text</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">actions</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Action buttons or elements</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
